import React, { useState } from 'react';
import { Share2, CheckCircle } from 'lucide-react';

const ShareButton = ({ className = "" }) => {
  const [copied, setCopied] = useState(false);
  
  const currentUrl = window.location.href;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // 브라우저가 clipboard API를 지원하지 않는 경우
      const textArea = document.createElement('textarea');
      textArea.value = currentUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      onClick={copyToClipboard}
      className={`flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors border border-blue-200 ${className}`}
    >
      {copied ? (
        <>
          <CheckCircle className="w-4 h-4" />
          복사완료!
        </>
      ) : (
        <>
          <Share2 className="w-4 h-4" />
          공유하기
        </>
      )}
    </button>
  );
};

export default ShareButton;